import React from 'react';
import * as BsIcons from 'react-icons/bs';
import SafeIcon from '../common/SafeIcon';

const { BsActivity } = BsIcons;

const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-100 py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center text-center mb-12">
          <div className="flex items-center space-x-2 mb-6">
            <SafeIcon icon={BsActivity} className="text-2xl text-indigo-600" />
            <span className="text-xl font-bold tracking-tight text-slate-900 uppercase">
              Neuro<span className="text-indigo-600">Pulse</span> <span className="text-slate-400 font-light">Insights</span>
            </span>
          </div>
          <p className="text-slate-500 max-w-2xl leading-relaxed">
            NeuroPulse Insights is an independent review hub and resource center dedicated to brain health and cognitive science. We may receive commissions for products recommended on this site.
          </p>
        </div>
        
        <div className="text-[11px] text-slate-400 space-y-4 max-w-5xl mx-auto text-center border-t pt-12">
          <p>*The information on this site is for educational purposes only and not intended as medical advice.</p>
          <p>ClickBank is the retailer of products on this site. CLICKBANK® is a registered trademark of Click Sales Inc. Boise, ID 83709, USA.</p>
          <p>Copyright © 2025 NeuroPulse Insights. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;